function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import Anchored from '../Anchored';
import OpenableComponent from '../OpenableComponent';
import Tooltip from './Tooltip';

function getStaticAnchoredPosition(placement) {
  switch (placement) {
    case 'bottom':
      return 'psw-l-anchor-bottom-center psw-l-top-center';

    case 'top':
      return 'psw-l-anchor-top-center psw-l-bottom-center';

    case 'left':
      return 'psw-l-anchor-center-left psw-l-center-right';

    case 'right':
      return 'psw-l-anchor-center-right psw-l-center-left';

    default:
      return '';
  }
}
/**
 * AnchoredTooltip adds positioning to the Tooltip component and is compatible
 * with web-common-layers.
 *
 * ## Related Components
 * - [Tooltip](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Tooltip)
 * - [Anchored](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Anchored)
 * - [Trigger](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Trigger)
 */


var AnchoredTooltip = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(AnchoredTooltip, _OpenableComponent);

  var _super = _createSuper(AnchoredTooltip);

  function AnchoredTooltip() {
    _classCallCheck(this, AnchoredTooltip);

    return _super.apply(this, arguments);
  }

  _createClass(AnchoredTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var openOnMount = this.props.openOnMount;

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this.open();
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          qa = _this$props.qa,
          className = _this$props.className,
          header = _this$props.header,
          body = _this$props.body,
          cta = _this$props.cta,
          anchoredEl = _this$props.anchoredEl,
          idealPlacement = _this$props.idealPlacement,
          rest = _objectWithoutProperties(_this$props, ["id", "qa", "className", "header", "body", "cta", "anchoredEl", "idealPlacement"]);

      if (anchoredEl) {
        return /*#__PURE__*/React.createElement(Anchored, {
          to: anchoredEl,
          placement: idealPlacement,
          shouldFollow: true,
          hasArrow: true
        }, function (_ref) {
          var placement = _ref.placement,
              arrowXDiff = _ref.arrowXDiff,
              arrowYDiff = _ref.arrowYDiff,
              hideArrow = _ref.hideArrow;
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, _extends({}, rest, {
            className: className,
            show: _this2.isOpen(),
            id: id,
            qa: qa,
            header: header,
            body: body,
            cta: cta,
            placement: placement,
            arrowXDiff: arrowXDiff,
            arrowYDiff: arrowYDiff,
            hideArrow: hideArrow
          })));
        });
      }

      return /*#__PURE__*/React.createElement(Tooltip, _extends({}, rest, {
        show: this.isOpen(),
        id: id,
        qa: qa,
        header: header,
        body: body,
        cta: cta,
        className: classNames('psw-l-z-15', getStaticAnchoredPosition(idealPlacement)),
        placement: idealPlacement
      }));
    }
  }]);

  return AnchoredTooltip;
}(OpenableComponent);

AnchoredTooltip.defaultProps = {
  id: '',
  qa: '',
  className: '',
  header: null,
  body: null,
  cta: null,
  anchoredEl: null,
  idealPlacement: 'bottom',
  openOnMount: false,
  isOpen: null,
  closeDelay: 500,
  onClose: function onClose() {},
  onOpen: function onOpen() {}
};
AnchoredTooltip.propTypes = {
  /**
   * Unique id to allow associating the tooltip content with another element via
   * aria-describedby or aria-labelledby depending on your use case
   */
  id: PropTypes.string,

  /**
   * Root qa test automation id
   */
  qa: PropTypes.string,

  /**
   * Add additional css classes to the component
   */
  className: PropTypes.string,

  /**
   * The tooltip title
   */
  header: PropTypes.node,

  /**
   * The tooltip description
   */
  body: PropTypes.node,

  /**
   * CTA to dismiss the tooltip
   */
  cta: PropTypes.node,

  /**
   * The element to point to
   * The following check is added to ensure that we do not get an error on consuming app
   * on SSR context because HTMLElement is only defined on client side.
   */
  anchoredEl: typeof HTMLElement === 'undefined' ? PropTypes.any : PropTypes.instanceOf(HTMLElement),

  /**
   * The placement may vary (if using anchoredEl prop) depending on how much space is in the
   * viewport to show the tooltip content. If there is no room the tooltip
   * may be placed in a flipped orientation.
   */
  idealPlacement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * Whether or not to open the Overlay when it is mounted. This prop will only take
   * effect if the Overlay is not controlled
   */
  openOnMount: PropTypes.bool,

  /**
  * If set to null the state will be managed internally. If a boolean is passed
  * the overlay will be controlled
  */
  isOpen: PropTypes.bool,

  /**
  * Event callback called when the Overlay is opened
  */
  onOpen: PropTypes.func,

  /**
  * Event callback called when the Overlay is closed
  */
  onClose: PropTypes.func
};
export default AnchoredTooltip;